import { on } from 'delegated-events';

const RedirectMessage = (() => {

    const Selectors = {
        ELEMENT: '.js-redirect-message',
        RD_CLOSE: '[data-redirect-message="close"]'
    };

    class RedirectMessage {
        constructor(element) {
            this.isOpen = true;
            this.element = element;
            this.addEvents();
            this.clickOutside = this.handleClickOutside.bind(this);
            document.addEventListener('click', this.clickOutside);

        }


        addEvents() {
            on('click', Selectors.RD_CLOSE, this.handleClickClose.bind(this));
        }

        close() {
            this.isOpen = false;
            this.element.remove()
            document.removeEventListener('click', this.clickOutside);
        }

        handleClickOutside(event) {
            const isClickInside = this.element.contains(event.target);

            if (!isClickInside) {
                this.handleClickClose(event);
            }
        }

        handleClickClose(event) {
            this.close();

            event.preventDefault();
        }
    }

    [].forEach.call(document.querySelectorAll(Selectors.ELEMENT), (item) => {
        new RedirectMessage(item);
    });
    return RedirectMessage;
})();

export default RedirectMessage;
